import { AGENT_TYPES as e } from "../../interfaces/AgentConfigurationInterfaces.js";
//#region src/resources/agent-configuration/AgentConfigurationResource.mocks.ts
var t = 2e3, n = (e) => e.toISOString().split(".")[0] + "Z", r = (t) => {
	let r = /* @__PURE__ */ new Date(), i = /* @__PURE__ */ new Date(r.getTime() - (t + 1) * 24 * 60 * 60 * 1e3);
	return {
		id: `agent-${t + 1}`,
		name: `Conversational Agent ${t + 1}`,
		description: t % 2 == 0 ? `Description for agent ${t + 1}` : "",
		agentType: e.SEARCH_AGENT,
		passageRetrievalModelId: `passage-model-${t % 3 + 1}`,
		answerModelId: `answer-model-${t % 3 + 1}`,
		followUpModelId: `followup-model-${t % 3 + 1}`,
		numberOfItemsToConsider: t % 2 == 0 ? 50 + t * 5 : void 0,
		followUpEnabled: !0,
		createdDate: n(i),
		modifiedDate: n(r)
	};
}, i = (e, t) => {
	let n = t?.page ?? 0, i = t?.perPage ?? 25, a = Array.from({ length: e }, (e, t) => r(t));
	t?.sortingType && a.sort((e, n) => {
		let r = e[t.sortingType], i = n[t.sortingType], a = String(r ?? "").localeCompare(String(i ?? ""));
		return t.sortingOrder === "DSC" ? -a : a;
	});
	let o = n * i, s = a.slice(o, o + i);
	return {
		pagination: {
			page: n,
			perPage: i,
			totalItems: e,
			totalPages: Math.ceil(e / i)
		},
		items: s
	};
}, a = (e) => {
	let t = n(/* @__PURE__ */ new Date());
	return {
		id: `agent-${Date.now()}`,
		name: e.name,
		description: e.description ?? "",
		agentType: e.agentType,
		passageRetrievalModelId: e.passageRetrievalModelId,
		answerModelId: "mock-answer-model-id",
		followUpModelId: "mock-followup-model-id",
		numberOfItemsToConsider: e.numberOfItemsToConsider,
		followUpEnabled: e.followUpEnabled,
		createdDate: t,
		modifiedDate: t
	};
}, o = [], s = (e = 5) => {
	o = Array.from({ length: e }, (e, t) => r(t));
}, c = (e, t) => {
	let r = o.findIndex((t) => t.id === e);
	return r === -1 ? null : (o[r] = {
		...o[r],
		...t,
		modifiedDate: n(/* @__PURE__ */ new Date())
	}, o[r]);
}, l = (e, n = t) => new Promise((t) => {
	setTimeout(() => t(e), n);
});
s(5);
//#endregion
export { a as createMockAgentFromRequest, r as createMockAgentItem, i as createMockAgentListResponse, s as initializeMockAgentStore, c as updateMockAgent, l as withDelay };

//# sourceMappingURL=AgentConfigurationResource.mocks.js.map